import { useParams } from "react-router-dom";
import { MapView } from "../../../../constant/VectorTileLayerType";
import CountryVectorTileLayer from "../../layers/CountryVectorTiles/CountryVectorTileLayer";

const includedCountries: string[] = [
  "GB",
  "US",
];

const InrixAverageSpeedMapView = () => {
  const visible = useParams().layer === MapView.INRIX_AVERAGE_SPEED;

  return (
    <CountryVectorTileLayer visible={visible} inclusions={includedCountries} />
  );
};

export default InrixAverageSpeedMapView;
